import type { APP_CONSTANTS } from '~/common/explicit-exports';
import { useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';

interface CreateContentProviderContentParams {
  contentId: string;
  provider:
    | typeof APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING
    | typeof APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY;
  itemFolderId?: string;
}

export function createContentProviderContent({
  contentId,
  provider,
  itemFolderId,
}: CreateContentProviderContentParams) {
  return FetchPromise.post(`content_provider_contents/${provider}`, {
    content_id: contentId,
    item_folder_id: itemFolderId,
  });
}

export function useCreateContentProviderContent() {
  return useDefaultMutation((params: CreateContentProviderContentParams) => createContentProviderContent(params));
}
